import React from "react";
import { FaEdit } from "react-icons/fa";
import EditMailingAddress from "./EditMailingAddress";
import Skeleton from "react-loading-skeleton";

const LocationAndRoles = ({ userProfile, isLoading, refetch }) => {
  const user = JSON.parse(localStorage.getItem("user"));
  return (
    <>
      <div className="d-flex justify-content-between mb-2">
        <h4 className="small-text font-weight-bold">Location/ Roles:</h4>
      </div>
      <div className="row small-text">
        <div className="col-md-6">
          <div className="fs-13 font-weight-bold">
            {user?.roles[0]?.clinicalLocationName}
          </div>
          <ul className="fs-13 mt-2 pl-5 list-unstyled">
            {user?.roles.map((role) => (
              <li className="pb-2" key={role.id}>
                -{" "}
                {role.role === "HEALTH_CARE_PROVIDER"
                  ? "Healthcare Provider"
                  : ""}{" "}
                ({user?.organizations[0]?.careProvider?.position?.abbreviation})
              </li>
            ))}
          </ul>
        </div>
      </div>
      <hr />
    </>
  );
};

export default LocationAndRoles;
